<template>
  <v-content>
      <v-dialog persistent v-model="dialogPrealerta"  max-width="1300" class="primary">
            <v-toolbar  dark color="primary" class="font-weight-light body-1">
                <h4>Prealertas</h4>
                
            </v-toolbar>
            <v-card>
            <v-container fluid>
                <v-row > 
                  <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Buscar"
                    class="pa-4"
                    single-line
                    hide-details
                  ></v-text-field>
                </v-row>
                  <v-flex xs12 sm12 md12 lg12 xl12>
                    <v-data-table
                        :headers="cabeceraDetalles"
                        item-key="Consignatorio" 
                        :search="search"
                        single-select
                        :single-expand="show-expand"
                        :expanded.sync="expanded"
                        :items="detalles"
                        class="elevation-1"
                        show-expand
                        v-model="selected"
                        @click:row="rowClick">
                        <template v-slot:expanded-item="{ headers, item }">
                          <v-row>
                              <v-col cols="12" sm="12">
                                <v-card
                                    class="mx-auto"
                                    max-width="344"
                                  >
                                    <v-img
                                      :src="item.Picture"
                                      height="300px"
                                      gradient="to top, rgba(0, 0, 0, .0), rgba(0, 0, 0, .5)"
                                    > <v-card-actions>
                                       <v-card-title class="white--text">
                                      Comprobante de Pago
                                      </v-card-title>
                                      <v-btn
                                        :loading="loading5"
                                        :disabled="loading5"
                                        color="blue-grey"
                                        class="ma-2 white--text"
                                        fab
                                        @click="loader = 'loading5'"
                                      >
                                        <v-icon dark>mdi-cloud-download</v-icon>
                                      </v-btn>
                                    </v-card-actions></v-img>
                                    
                                </v-card>
                              </v-col>
                          </v-row>
                          <td> {{item.Consignatorio}}  <br>
                          <strong> Tipo de Preaviso: </strong> {{item.Tipo}} </td>
                          <td>Tracking: {{item.Tracking}} <br>
                          Fecha: {{item.Fecha}} </td>
                          <td> <strong> Cedula:</strong> {{item.Cedula}}  <br>
                           <strong> Profesion: </strong> {{item.Profesion}} <br>
                           <strong> Telefono Habitación: </strong> {{item.TelefonoCasa}} <br>
                           <strong> Telefono Móvil: </strong> {{item.TelefonoMovil}} <br>
                          <strong>  Tipo Cédula: </strong> {{item.TipoCedula}} <br>
                          <strong>  Dirección: </strong>{{item.Direccion}}  <br> </td>
                        </template>
                        <template slot="no-data">
                            <h3>No hay artículos agregados al detalle.</h3>
                        </template> 
                        <template v-slot:item.actionmovimiento="{ item }">
                          <v-icon
                            large
                            color="error"
                            @click="deleteEvent(item.id)"
                          >
                            mdi-delete
                          </v-icon>
                        </template>
                        <template v-slot:item.actioncantidad="{ item }"> 
                          <v-text-field v-model="item.cantidadIngreso">  </v-text-field>
                        </template> 

                    </v-data-table>
                  </v-flex>
                
            </v-container>
            </v-card>
      </v-dialog>
      <v-dialog persistent v-model="dialogDeposito"  max-width="500" class="primary">
            <v-toolbar  dark color="primary" class="font-weight-light body-1">
                <h4>Pago en Deposito</h4>
            </v-toolbar>
            <v-card>
            <v-container fluid>
                <div> Cuentas Sistemas Informáticos Noah S.R.L.
                  <br> BAC SAN JOSE <br>
                  $ 939993267          cc	10200009399932673 <br>
                  ₡939993283		cc	10200009399932839  <br>
                  IBAN CR23010200009399932839 <br>
                  Cédula Jurica: 3102776292 </div>
                <v-row > 
                  <v-text-field @keyup.enter="PagoDeposito()" rounded="" v-model="depositoPagar"  label="Pago en deposito"></v-text-field>
                </v-row>
                <v-row > 
                  <v-select  rounded="" v-model="banco" :items="bancos" label="Banco"></v-select>
                </v-row>
                <v-row > 
                  <v-text-field @keyup.enter="PagoDeposito()" rounded="" v-model="comprobantePago"  label="Número de referencia"></v-text-field>
                </v-row>
                <v-row > 
                  <v-text-field @keyup.enter="PagoDeposito()" rounded="" v-model="señas"  label="Otras señas"></v-text-field>
                </v-row>
                <v-row>
                    <v-btn class="mr-2 mx-2" @click="PagoDeposito()"> <v-icon> mdi-check-circle </v-icon> </v-btn>
                    <v-btn @click="limpiarPago()"> <v-icon> mdi-exit-to-app </v-icon> </v-btn>
                </v-row>
            </v-container>
            </v-card>
      </v-dialog>
      <v-dialog persistent v-model="dialogSinpe"  max-width="300" class="primary">
            <v-toolbar  dark color="primary" class="font-weight-light body-1">
                <h4>Pago en SINPE Móvil</h4>
            </v-toolbar>
            <v-card>
            <div> Número para SINPE.
                  <br> SIMPE MOVIL: 84610243  <br>
                  Cuenta  nombre de Jeffry Sequeira Araya <br>
            </div>
            <v-container fluid>
                <v-row > 
                  <v-text-field @keyup.enter="PagoSinpe()" rounded="" v-model="depositoPagar"  label="Pago en SINPE Móvil"></v-text-field>
                </v-row>
                 <v-row > 
                  <v-text-field @keyup.enter="PagoSinpe()" rounded="" v-model="comprobantePago"  label="Número de SINPE"></v-text-field>
                </v-row>
                <v-row > 
                  <v-text-field @keyup.enter="PagoSinpe()" rounded="" v-model="señas"  label="Otras señas"></v-text-field>
                </v-row>
                <v-row>
                    <v-btn class="mr-2 mx-2" @click="PagoSinpe()"> <v-icon> mdi-check-circle </v-icon> </v-btn>
                    <v-btn @click="limpiarPago()"> <v-icon> mdi-exit-to-app </v-icon> </v-btn>
                </v-row>
            </v-container>
            </v-card>
      </v-dialog>
      <v-dialog persistent v-model="dialogEfectivo"  max-width="300" class="primary">
            <v-toolbar  dark color="primary" class="font-weight-light body-1">
                <h4>Pago en Efectivo</h4>
                
            </v-toolbar>
            <v-card>
            <v-container fluid>
                <v-row > 
                  <v-text-field @keyup.enter="PagoEfectivo()" rounded="" v-model="efectivoPagar"  label="Pago en efectivo"></v-text-field>
                </v-row>
                <v-row>
                    <v-btn class="mr-2 mx-2" @click="PagoEfectivo()"> <v-icon> mdi-check-circle </v-icon> </v-btn>
                    <v-btn @click="limpiarPago()"> <v-icon> mdi-exit-to-app </v-icon> </v-btn>
                </v-row>
            </v-container>
            </v-card>
        </v-dialog>
      <v-dialog persistent v-model="dialogCheque"  max-width="300" class="primary">
            <v-toolbar  dark color="primary" class="font-weight-light body-1">
                <h4>Pago en Cheque</h4>
                
            </v-toolbar>
            <v-card>
            <v-container fluid>
                <v-row > 
                  <v-text-field @keyup.enter="PagoCheque()" rounded="" v-model="depositoPagar"  label="Pago en Cheque"></v-text-field>
                </v-row>
                <v-row > 
                  <v-select  rounded="" v-model="banco" :items="bancos" label="Banco"></v-select>
                </v-row>
                 <v-row > 
                  <v-text-field @keyup.enter="PagoCheque()" rounded="" v-model="comprobantePago"  label="Número de Cheque"></v-text-field>
                </v-row>
                 <v-row > 
                  <v-text-field @keyup.enter="PagoCheque()" rounded="" v-model="señas"  label="Otras señas"></v-text-field>
                </v-row>
                <v-row>
                    <v-btn class="mr-2 mx-2" @click="PagoCheque()"> <v-icon> mdi-check-circle </v-icon> </v-btn>
                    <v-btn @click="limpiarPago()"> <v-icon> mdi-exit-to-app </v-icon> </v-btn>
                </v-row>
            </v-container>
            </v-card>
      </v-dialog>
  <v-img height="200"
    dark
    :src="require('@/assets/home-hero.jpg')"
    class="white--text"
    gradient="to right, rgba(5, 11, 31, .8), rgba(5, 11, 31, .8)"
  >
  <v-btn color="white"  text rounded @click="getEvents"> <v-icon  >mdi-alarm-light</v-icon> Ver Prealertas</v-btn>
  <v-btn color="white"  text rounded > <v-icon >mdi-account-circle</v-icon> Sesiones</v-btn>
  
    <v-row
      align="center"
      justify="center" >
      <v-col class="text-center" cols="12">
        <v-flex xs12>
      
        <h1 class="Titulo text-uppercase">Preaviso </h1>
      <h4 class="subheading"> <v-icon> mdi-phone </v-icon>"TicoBuy"</h4> 
      </v-flex>
        
      </v-col>
    </v-row>
  </v-img>
      <v-tabs 
        background-color="primary"
        class="elevation-1 white--text"
        slider-color="primary" fixed-tabs
        >
          <v-btn class="white--text" text rounded @click="EsNormal()"><v-icon  class="mx-2 hidden-sm-and-down">mdi-alert-plus </v-icon> Normal </v-btn>
          <v-btn class="white--text" text rounded @click="EsOtro()"><v-icon  class="mx-2 hidden-sm-and-down">mdi-brightness-percent </v-icon> Exención </v-btn>
      </v-tabs>
    <v-stepper  v-model="e6" vertical>
    <v-stepper-step editable="true" :complete="e6 > 1" step="1">
      Paso #1: Información del paquete
    <small> Completa los datos y avísanos que tus paquetes vienen en camino.</small>
    </v-stepper-step>
    <v-stepper-content step="1">
      <v-form ref="form1" v-model="validHacienda">
       <v-card>
         
            <v-card-text>
              <v-container grid-list-md>
                <v-layout wrap>
                <v-flex xs12 sm6 md6>
                    <v-text-field :rules="nameRules" @input="AsignarCurier()" prepend-icon="mdi-qrcode-scan" v-model="tracking" label="Número de tracking">
                    </v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3 >
                    <v-select  :rules="[v => v != '' || 'La compañia es Requerida']" prepend-icon="mdi-truck" v-model="curier"
                    :items="Curiers" label="Compañia Courier">
                    </v-select>
                </v-flex>
                <v-flex xs12 sm6 md3>
                    <v-combobox :rules="[v => v != '' || 'La compañia es Requerida']" :items="tiendas" prepend-icon="mdi-storefront" v-model="tienda" label="Tienda donde compraste">
                    </v-combobox>
                </v-flex>
                <v-flex xs12 sm6 md3>
                    <v-text-field :rules="[v => v != '' || 'El valor es Requerido']" prepend-icon="mdi-cash-usd-outline" v-model="valordelpaquete" label="Valor del Paquete $"> $
                    </v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3>
                    <v-text-field :rules="nameRules" prepend-icon="mdi-account" v-model="consignatorio" label="Consignatorio">
                    </v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3 v-if="!esNormal">
                    <v-select  prepend-icon="mdi-identifier" v-model="TipoCedula"
                    :items="TipoCedulas" label="Tipo de Cédula">
                    </v-select>
                </v-flex>
                <v-flex xs12 sm6 md3 v-if="!esNormal">
                    <v-text-field  prepend-icon="mdi-identifier" v-model="Cedula" label="Número de cédula">
                    </v-text-field>
                </v-flex>
                
                <v-flex xs12 sm6 md3 v-if="!esNormal">
                    <v-text-field  prepend-icon="mdi-head-alert" v-model="EstadoCivil" label="Estado Civil">
                    </v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3 v-if="!esNormal">
                    <v-text-field  prepend-icon="mdi-doctor" v-model="Profesion" label="Profesión">
                    </v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3 v-if="!esNormal">
                    <v-text-field  prepend-icon="mdi-cellphone" v-model="telefonoMovil" label="Teléfono Móvil">
                    </v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3 v-if="!esNormal">
                    <v-text-field  prepend-icon="mdi-deskphone" v-model="telefonoCasa" label="Teléfono Casa">
                    </v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md3 v-if="!esNormal">
                    <v-text-field  prepend-icon="mdi-home-city" v-model="Provincia" label="Provincia">
                    </v-text-field>
                </v-flex>
                <v-flex xs12 sm6 md6 v-if="!esNormal">
                    <v-text-field  prepend-icon="mdi-map-marker-multiple" v-model="Direccion" label="Dirección">
                    </v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md6>
                    <v-text-field :rules="direcciónRules" prepend-icon="mdi-comment" v-model="descripcion" label="Descripción del articulo">
                    </v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md12 v-show="valida">
                    <div class="red--text" v-for="v in validaMensaje" :key="v" v-text="v">
                    </div>
                </v-flex>
                </v-layout>
             </v-container>
            </v-card-text>
           
        </v-card>
      <v-btn :disabled="!validHacienda" color="primary" @click="e6 = 2">Continue</v-btn>
      <v-btn text>Cancel</v-btn>
      </v-form> 
    </v-stepper-content>

    <v-stepper-step editable="true" :complete="e6 > 2" step="2">Paso #2: Añade la factura
       <small>Pega el texto debajo o selecciona el archivo con la factura <strong> equipo Noah se encarga </strong> si algo hace falta</small></v-stepper-step>

    <v-stepper-content step="2">
      <v-card>
        <template>
              <div>
              <div >
                <p>Cargar Imagen o Documento:</p>
                <input type="file" @change="onChangeFileUpload" accept="image/*" >
              </div>
              <div>
                <p>Progreso: {{uploadValue.toFixed()+"%"}}
                <progress id="progress" :value="uploadValue" max="100" ></progress>  </p>
                <v-btn @click="onUpload()" class="ma-2" color="indigo" dark>
                  <v-icon dark>mdi-cloud-upload</v-icon>
                </v-btn>
              </div>
              <div>
                  <img class="preview" :src="picture">
              </div>
            </div>
            </template>
      </v-card>   
      <v-btn color="primary" v-on:click="addEvent()">Continue</v-btn>
      <v-btn text>Cancel</v-btn>
    </v-stepper-content>
  </v-stepper>
  </v-content>
</template>


<script>
  import { db } from '@/main'
  import axios from 'axios';
  import VueRecaptcha from 'vue-recaptcha';
  import firebase from "firebase";
  
  export default {
    name: 'Upload',
    data () {
      components: { VueRecaptcha }
      return {
        TipoCedula : '',
        detalles:[],
        search: '',
        cabeceraDetalles: [
        { text: 'Consignatorio', value: 'Consignatorio'  },
        { text: 'Curier', value: 'Curier'  },
        { text: 'Tienda', value: 'Tienda' },
        {text: 'Tipo Prealerta' , value: 'Tipo', sortable: false},
        { text: 'Tracking', value: 'Tracking', sortable: false  },
        { text: '', value: 'data-table-expand' },
        { text: 'Detalles', value: 'actionmovimiento', sortable: false },
        ],
        TipoCedulas: ["Fisica","Juridica","Dimex","Otro"],
        EstadoCivil: '',
        Profesion: '',
        Cedula: '',
        Direccion: '',
        telefonoMovil: '',
        telefonoCasa: '',
        Provincia: '',
        e6: 1,
        imageData: null,
        picture: null,
        uploadValue: 0,
        dragAndDropCapable: false,
        dialogPrealerta: false,
        selectedFile: null,
        Curiers: ["UPS","Aeropost","China Post","DHL","Fedex","PriceSmart","Otros"],
        emailRules: [
            v => !!v || 'El correo electrónico es requerido',
            v => /.+@.+\..+/.test(v) || 'El correo electrónico es requerido debe ser válido',],
            cedulaRules: [value => !!value || 'La cédula es requerida'
            , value => (value && value.length >= 9) || 'Debe ingresar 9 carácteres como mínimo',],
        nameRules: [
            value => !!value || 'El nombre es requerido',
            value => (value && value.length >= 10) || 'Debe ingresar 10 carácteres como mínimo',
            ],
        direcciónRules: [
            value => !!value || 'La dirección exacta es requerida',
            value => (value && value.length >= 15) || 'Debe ingresar 15 carácteres como mínimo',
            ],
        celRules: [
            value => !!value || 'El número es requerido',
            value => (value && value.length >= 8) || 'Debe ingresar 8 carácteres como mínimo', 
            ],
        valordelpaquete:0,
        tienda : '',
        esNormal: true,
        Categoria: 'Normal',
        curier: '',
        consignatorio : this.$store.state.usuario.nombre,
        files: [],
        descripcion: '',
        loading5: false,
        start: '',
        loader: null,
        tracking :'',
        tiendas: [
          'Ebay',
          'Amazon',
          'Victoria Secret',
          'American Eagle',
          'Aeropostale',
          'Otros',
        ],

      }
    },
    watch: {
      loader () {
        const l = this.loader
        this[l] = !this[l]

        setTimeout(() => (this[l] = false), 3000)

        this.loader = null
      },
    },
    methods: {
    
    async addEvent () {
      var momentoActual = new Date(); 
      var Año = momentoActual.getFullYear(); 
      var Mes = momentoActual.getMonth(); 
      var Dia = momentoActual.getDate();
      this.start =  Año + "-"+"0" + Mes + "-"+"0" + Dia;
      if (this.picture != null){
      db.collection("TicoBuyPrealerta").add({
          Consignatorio: this.consignatorio,
          Tracking: this.tracking,
          Curier: this.curier,
          Tipo: this.Categoria,
          Tienda: this.tienda,
          Valor: this.valordelpaquete,
          TipoCedula: this.TipoCedula,
          Cedula: this.Cedula,
          EstadoCivil: this.EstadoCivil,
          Profesion: this.Profesion,
          TelefonoMovil: this.telefonoMovil,
          TelefonoCasa: this.telefonoCasa,
          Provincia: this.Provincia,
          Direccion: this.Direccion,
          Fecha: this.start,
          Picture: this.picture,
          })
          this.limpiar()
          alert("Feliciades "+this.$store.state.usuario.nombre+" Haz creado un Pre-aviso")
          } else
          alert("Debe Cargar su factura antes de continuar")
      
    },
    async getEvents () {
      this.dialogPrealerta = true;
      let snapshot = await db.collection('TicoBuyPrealerta').get()
      const events = []
      snapshot.forEach(doc => {
        let appData = doc.data()
        appData.id = doc.id
        events.push(appData)
      })
      this.detalles = events
    },
    Download(Doc){
      axios({
        url:"Doc",
        method:'GET',
        responseType: 'blob'
      }).then((response) => {
        var fileUrl = window.URL.createObjectURL(new Blob([responde.data]))
        varfileLink = document.createElement('a')
        FileLink.href = fileUrl
      })

    },
    limpiar(){
      this.Categoria = '';
      this.tracking = '';
      this.consignatorio = '';
      this.curier = '';
      this.tienda = '';
      this.valordelpaquete = '';
      this.TipoCedula = '';
      this.Cedula = '';
      this.EstadoCivil = '';
      this.Profesion = '';
      this.telefonoMovil = '';
      this.telefonoCasa = '';
      this.Provincia = '';
      this.Direccion = '';
    },
    async deleteEvent (ev) {
     
     if(confirm("Esta seguro que desea eliminar esta prealerta?")){
     let temp = 0;
     await db.collection("TicoBuyPrealerta").doc(ev).delete(),
     
     this.getEvents()
      }
    },
    submitForm(){
            let formData = new FormData();
            formData.append('file', this.file);
  
            this.axios.post('api.php',
                formData,
                {
                headers: {
                    'Content-Type': 'multipart/form-data'
                }
              }
            ).then(function(data){
              console.log(data.data);
            })
            .catch(function(){
              console.log('FAILURE!!');
            });
      },
      EsNormal(){
        this.esNormal = true;
        this.Categoria = "Normal";
      },
      EsOtro(){
        this.esNormal = false;
        this.Categoria = "Exención";
      },
      previewImage(event) {
      this.uploadValue=0;
      this.picture=null;
      this.imageData = event.target.files[0];
      this.onUpload();
    },
    onUpload(){
      const storageRef=firebase.storage().ref(`${this.selectedFile.name}`);
      const task = storageRef.put(this.selectedFile);
      task.on('state_changed',snapshot=>{
        let percentage = (snapshot.bytesTransferred/snapshot.totalBytes)*100;
        this.uploadValue = percentage;
      }, error=>{console.log(error.message)},
      ()=>{this.uploadValue=100;
          task.snapshot.ref.getDownloadURL().then((url)=>{
          this.picture =url;
        });
      }
      );
    },
  
      onChangeFileUpload(event){
        this.selectedFile = event.target.files[0];
      },
      AsignarCurier(){

        if(this.tracking.substring(0, 2) == "1Z"){
          this.curier = "UPS"
        }
      },
      
    Afiliarse(){
          let self=this;
          let header={"Authorization" : "Bearer "};
                let configuracion= {headers : header};
                axios.post('api/Usuarios/CrearLocalidad',{
                      'NombreUsuario':this.nombreUsuario,
                      'CedulaUsuario':this.cedulaUsuario,
                      'TipoCedulaUsuario': this.tipo_documento,
                      'TelefonoUsuario': this.telefonoUsuario,
                      'CorreoUsuario': this.correoUsuario,
                      'Password': this.password,
                      'Localidad': this.nombreLocalidad,
                      'Direccion': this.Direccion,
                      'RazonSocial': this.RazonSocial,
                      'Regimen': this.Regimen,
                      'PuntoVenta': this.PuntoVenta,
                      'CasaMatriz': this.CasaMatriz,
                      'TipoCedulaLocalidad': this.TipoCedulaLocalidad,
                      'TelefonoLocalidad': this.TelefonoLocalidad,
                      'CedulaLocalidad': this.CedulaLocalidad,
                      'Provincia': this.Provincia,
                      'CantidadFacturas': this.CantidadFacturas,
                      'Canton': this.Canton,
                      'Distrito': this.dis2,
                      'CorreoLocalidad': this.CorreoLocalidad,
                      'UsuarioATV': this.UsuarioATV,
                      'ContraseñaATV': this.ContraseñaATV,
                      'PIN': this.Pin,
                      'TipoCambio': this.TipoCambio,
                      'CodigoActividad': this.CodigoActividad,
                      'NoActividadEconomica': this.NoActividadEconomica,
                      'TipoPago': this.tipoPago,
                      'DetallePago': this.detalle,
                      'TotalPago': this.totalPagar,
                      'NombredelPlan': this.NombredelPlan,
                      
                },configuracion).then(function (response) {
                    alert("Felicidades, haz creado tu cuenta un representante se podrá en contacto con tigo en breve para que empieces a utilizar Noah");
                    self.$router.push({ name: 'login' });
                  })
                  .catch(function (error) {
                    alert("Error, favor revisar datos o solicite ayuda al 4070-1889");
                })
    },

    },
  }
</script>

<style scoped>
img.preview {
    width: 200px;
}

.form{
    display: block;
    height: 400px;
    width: 400px;
    background: #ccc;
    margin: auto;
    margin-top: 40px;
    text-align: center;
    line-height: 400px;
      border-radius: 4px;
  }
  #app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 60px;
}
</style>

